module.exports = __webpack_public_path__ + "img/back_300.27df14ec.png";